"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var AnimationObject = (function () {
    function AnimationObject(rawData, version) {
        this._rawData = rawData;
        this._rawDataVer = version;
    }
    Object.defineProperty(AnimationObject.prototype, "rawDataVersion", {
        get: function () {
            return this._rawDataVer;
        },
        enumerable: true,
        configurable: true
    });
    AnimationObject.prototype.clone = function () {
        throw new Error(this.constructor.name + ": Clone not supported");
    };
    ;
    AnimationObject.prototype.toRawData = function () {
        return _.cloneDeep(this._rawData);
    };
    return AnimationObject;
}());
exports.AnimationObject = AnimationObject;
//# sourceMappingURL=AnimationObject.js.map